@use '../../../../../styles/Colors.scss' as Colors;
@use '../../../../../styles/Constants.scss' as Constants;

.body-grid {
	display: grid;
	grid-template-rows: auto 1fr;
	grid-template-columns: 5fr 2fr;
	grid-template-areas:
		'meta right'
		'fields right';
	gap: Constants.$val-spacing-m;
	padding: Constants.$val-spacing-m;
	box-sizing: border-box;
	overflow: hidden;
}

.section {
	grid-area: meta;
	display: flex;
	flex-direction: row;
	border: 1px solid Colors.$col-greyConnection;
	padding: Constants.$val-spacing-s;
	width: inherit;
}

.checkbox {
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	gap: Constants.$val-spacing-xs;
	font-size: Constants.$val-fontSizeRegular;
	padding-left: Constants.$val-spacing-l;
}

.fields-pane {
	grid-area: fields;
	display: flex;
	flex-direction: column;
	min-height: 0;
	overflow: auto;
}

.fields-header {
	padding: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-s;
	border: 1px solid Colors.$col-greyConnection;
}

.header-title {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: Constants.$val-spacing-s 0;
	gap: Constants.$val-spacing-xs;
}

.hint-title {
	font-size: Constants.$val-fontSizeSmall;
	color: Colors.$col-greyDark;
}

.hint-sub {
	font-size: Constants.$val-fontSizeSmall;
	color: Colors.$col-grey;
}

.picker-area {
	flex: 1 1 auto;
	min-height: 0;
	min-width: 0;
	border: 1px solid Colors.$col-greyConnection;
	border-radius: Constants.$val-borderRadius-l;
	padding: Constants.$val-spacing-s;
	overflow: hidden;
}

.picker-inner {
	height: 100%;
	width: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	min-height: 0;
}

.right-pane {
	grid-area: right;
	display: flex;
	flex-direction: column;
	padding: Constants.$val-spacing-s;
	border: 1px solid Colors.$col-greyConnection;
	width: max;
	height: max;
	min-height: 0;
	overflow: auto;
}

.label {
	font-size: Constants.$val-fontSizeRegular;
	color: Colors.$col-greyDark;
	padding-bottom: Constants.$val-spacing-s;
}

.text-input {
	height: Constants.$val-inputHeight;
	padding: Constants.$val-inputPadding;
	border: 1px solid Colors.$col-design-gray300;
	font-size: Constants.$val-fontSizeRegular;
	width: 412px;
	box-sizing: border-box;
}

.search-field {
	display: flex;
	flex-direction: column;
}

.field-pane-wrapper {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-s;
	min-height: 0;
	flex: 1 1 auto;
}

.card {
	display: flex;
	flex-direction: row;
	align-items: center;
	border: 1px solid Colors.$col-greyConnection;
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
	background-color: Colors.$col-design-grey13;
	font-size: Constants.$val-fontSizeRegular;
	width: fit-content;
}

.close-icon {
	padding-left: Constants.$val-spacing-s;
	color: Colors.$col-greyDark;
	cursor: pointer;
}

.title {
	display: flex;
	flex-direction: row;
	font-size: Constants.$val-fontSizeRegular;
}

.info-icon {
	color: Colors.$col-design-blue500;
	cursor: pointer;
}

.card-container {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: Constants.$val-spacing-s;
	padding-left: Constants.$val-spacing-s;
}

$val-rt-card-height: 360px;

.cards-scroll {
	height: 100%;
	width: 100%;
	overflow: auto;
	min-height: 0;
}

.cards-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: Constants.$val-spacing-m;
	align-items: start;
	min-height: 0;
}

.card-rt {
	display: flex;
	flex-direction: column;
	min-width: 0;
	height: $val-rt-card-height;
	border: 1px solid Colors.$col-design-gray300;
	background-color: Colors.$col-white;
	overflow: auto;
	position: relative;
}

.card-header {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: Constants.$val-spacing-s Constants.$val-spacing-m;
	font-size: Constants.$val-fontSizeSmall;
}

.card-title {
	font-size: Constants.$val-fontSizeRegular;
	font-weight: 600;
	color: Colors.$col-greyDark;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	text-transform: uppercase;
	display: flex;
	flex-direction: row;
	padding-bottom: Constants.$val-spacing-s;
}

.card-inactive {
	padding-top: Constants.$val-spacing-xs;
	padding-left: Constants.$val-spacing-xs;
	color: Colors.$col-design-red300;
	font-size: Constants.$val-fontSizeXSmall;
}

.revision-link {
	color: Colors.$col-design-blue500;
	cursor: pointer;
	padding-bottom: Constants.$val-spacing-s;
}

.card-body {
	flex: 1 1 auto;
	min-height: 0;
	overflow: auto;
	padding: Constants.$val-spacing-xs Constants.$val-spacing-xs;
}

@mixin block {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-s;
	background-color: Colors.$col-design-gray50;
	border: 2px solid Colors.$col-lighterGrey;
	padding: Constants.$val-spacing-xs;
}

.block {
	@include block;
	position: relative;

	&__primary {
		@include block;
		background-color: Colors.$col-design-blue100;
		border: 2px solid Colors.$col-design-blue300;
	}

	&__secondary {
		@include block;
		background-color: inherit;
		border: 2px solid Colors.$col-design-blue300;
	}
}

.block-header {
	color: Colors.$col-design-grey11;
	text-transform: uppercase;

	&__main {
		color: Colors.$col-design-blue500;
		text-transform: uppercase;
	}

	&__secondary {
		color: Colors.$col-design-grey11;
		text-transform: uppercase;
	}
}

.block-fields {
	display: flex;
	gap: Constants.$val-spacing-s;
	flex-direction: column;
	font-size: Constants.$val-fontSizeSmall;
}

.block-field {
	display: flex;
	flex-direction: row;
	padding: Constants.$val-spacing-xs;

	&__primary {
		background-color: Colors.$col-design-blue50;
	}

	&__secondary {
		background-color: Colors.$col-white;
	}

	&__highlighted {
		background-color: Colors.$col-orange-100;
	}
}

.block-field-radio {
	display: flex;
	flex-direction: row;
}

.selected-report-type {
	background-color: Colors.$col-orange-100;
}

.check-icon {
	height: Constants.$val-spacing-m;
	border-radius: 50px;
	background-color: Colors.$col-orange-600;
	padding: 1px;
	color: white;
	margin-left: Constants.$val-spacing-xs;
}

.card-rt-outdated {
	background-color: Colors.$col-design-red4;
}

.card-warn-corner {
	position: absolute;
	top: 6px;
	right: 8px;
	font-size: Constants.$val-fontSizeBig;
	line-height: 1;
	color: red;
}

.card-outdated-field {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	background-color: Colors.$col-design-red100;
	border: 1px solid Colors.$col-design-red300;
	color: Colors.$col-design-red300;
}

.warning-icon {
	color: red;
	padding-left: Constants.$val-spacing-xs;
	font-size: Constants.$val-fontSizeBig;
}

.card-outdated-field-name {
	color: Colors.$col-design-grey900;
}

.primary-blocks {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-xs;
	background: Colors.$col-design-blue200;
	border-radius: Constants.$val-spacing-xs;
	padding: Constants.$val-spacing-xs;
	margin-bottom: Constants.$val-spacing-s;
}

.secondary-blocks {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-xs;
	background: Colors.$col-design-gray50;
	border-radius: Constants.$val-spacing-xs;
	padding: Constants.$val-spacing-xs;
	border: 1px solid Colors.$col-lighterGrey;
	margin-bottom: Constants.$val-spacing-s;
}

.dialog {
	padding-top: 48px;
}

.pane-section {
	display: flex;
	flex-direction: column;
	border-bottom: 2px solid Colors.$col-greyConnection;
	background: Colors.$col-white;
}

.pane-section__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: Constants.$val-spacing-s;
	width: 100%;
	padding: Constants.$val-spacing-s Constants.$val-spacing-m;
	border: 0;
	background: Colors.$col-white;
	text-align: left;
	cursor: pointer;
}


.pane-section__header--warning {
	background: Colors.$col-design-red4;
}

.pane-section__header-left {
	display: flex;
	flex-direction: column;
	min-width: 0;
	flex: 1 1 auto;
}

.pane-section__title-row {
	display: flex;
	align-items: center;
	gap: Constants.$val-spacing-xs;
	min-width: 0;
}

.pane-section__title {
	display: flex;
	align-items: center;
	gap: Constants.$val-spacing-xs;
	font-size: Constants.$val-fontSizeRegular;
	color: Colors.$col-greyDark;
	min-width: 0;
}

.pane-section__subtitle {
	font-size: Constants.$val-fontSizeSmall;
	color: Colors.$col-grey;
	font-style: italic;
	margin-top: 2px;
}

.pane-section__chevron {
	flex: 0 0 auto;
	color: Colors.$col-greyDark;
	font-size: Constants.$val-fontSizeBig;
}

.pane-section__warning-icon {
	color: Colors.$col-design-red600;
	font-size: 12px;
	line-height: 1;
}

.action-button {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-xxs;
	color: Colors.$col-design-blue500;
	font-size: Constants.$val-fontSizeRegular;

	&--disabled {
		color: Colors.$col-design-grey10;
	}

	&:hover {
		cursor: pointer;
	}
}

.actions {
	display: flex;
	flex-direction: row;
	justify-content:space-between ;
	gap: Constants.$val-spacing-s;
	margin-top: Constants.$val-spacing-s;
	align-items: flex-end;
}

.action-buttons {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-s;
	align-items: flex-end;
}

.tooltip {
	display: flex;
	flex-direction: column;
	align-items: center;
	flex-direction: column;
	text-align: center;
}